export default "__VITE_ASSET__BMuAy9KB__"